import React, { useState } from 'react';
import _ from 'underscore';
import {} from './styles';
import { OuterContainer, SectionTitle } from '../styles';
import { EmailTabContainer, EmailTab, EmailContainer, SubjectInput, SubjectLabel } from '../../SettingsPage/styles';
import { Button } from '../../../components';
import QuillEditor from '../../../../components/QuillEditor/quillEditorEmail';

export const EmailTemplate = ({ configEmails, boilerPlateConfigEmails, updateEmails }) => {
  const boilerPlateEmails = JSON.parse(JSON.stringify(boilerPlateConfigEmails));
  delete boilerPlateEmails.value.credits;
  const [configEmailsList, setConfigEmailsList] = useState(configEmails);
  const [configActiveIndex, setConfigActiveIndex] = useState(0);
  const [boilerPlateEmailsList, setBoilerPlateEmailsList] = useState(boilerPlateEmails.value);
  const [boilerPlateActiveKey, setBoilerPlateActiveKey] = useState('appliedEmail');

  const getEmailTopicNames = (topic) => {
    if (topic === 'appliedEmail') return 'Candidate Applied';
    if (topic === 'rejectEmail') return 'Candidate Rejected';
    if (topic === 'ticketEmail') return 'Take Test';
    if (topic === 'inviteEmail') return 'Invite Reviewer';
    if (topic === 'testReminderEmail') return 'Test Reminder';
    if (topic === 'CVReminderEmail') return 'CV Reminder';
    if (topic === 'signUp') return 'Sign In Link';
    if (topic === 'testSubmitNotificationEmail') return 'Test Submitted Notification';
    if (topic === 'newApplicationEmail') return 'Customer Email';
  };

  const renderConfigTabs = () =>
    configEmails.map((email, index) => (
      <EmailTab active={configActiveIndex === index} onClick={() => setConfigActiveIndex(index)} key={index}>
        {getEmailTopicNames(email.key)}
      </EmailTab>
    ));

  const renderBoilerPlateTabs = () =>
    Object.keys(boilerPlateEmailsList).map((key) => {
      return (
        <EmailTab active={boilerPlateActiveKey === key} onClick={() => setBoilerPlateActiveKey(key)} key={key}>
          {getEmailTopicNames(key)}
        </EmailTab>
      );
    });

  const updateConfigChanges = (field, subfield, text, source, delta) => {
    let isPlaceholder = false;
    if (delta?.ops) {
      for (const d of delta.ops) {
        if (d.insert) {
          if (d.insert.charAt(0) === '[' && d.insert.charAt(d.insert.length - 1) === ']') isPlaceholder = true;
        }
      }
    }
    if (subfield === 'html' && source !== 'user' && !isPlaceholder) return;
    let configEmailsListCopy = JSON.parse(JSON.stringify(configEmailsList));
    if (configEmailsList[configActiveIndex].key === 'signUp') {
      configEmailsListCopy[configActiveIndex].value[subfield] = text;
    } else {
      configEmailsListCopy[configActiveIndex].value[field][subfield] = text;
    }
    setConfigEmailsList(configEmailsListCopy);
  };

  const updateBoilerPlateChanges = (field, subfield, text, source, delta) => {
    let isPlaceholder = false;
    if (delta?.ops) {
      for (const d of delta.ops) {
        if (d.insert) {
          if (d.insert.charAt(0) === '[' && d.insert.charAt(d.insert.length - 1) === ']') isPlaceholder = true;
        }
      }
    }
    if (subfield === 'html' && source !== 'user' && !isPlaceholder) return;
    let boilerPlateEmailsListCopy = JSON.parse(JSON.stringify(boilerPlateEmailsList));
    boilerPlateEmailsListCopy[boilerPlateActiveKey][field][subfield] = text;
    setBoilerPlateEmailsList(boilerPlateEmailsListCopy);
  };

  return (
    <OuterContainer>
      <SectionTitle>Email Template</SectionTitle>
      {/* Start of config emails */}
      <EmailTabContainer grids={configEmailsList.length}>{renderConfigTabs()}</EmailTabContainer>
      <EmailTabContainer grids={2} gridGap="35">
        {['en', 'sv'].map((lang, index) => {
          if (configEmailsList[configActiveIndex].key === 'signUp' && lang === 'sv') return null;
          return (
            <EmailContainer key={index}>
              <SubjectLabel>{lang === 'en' ? 'English' : 'Swedish'} Subject</SubjectLabel>
              <SubjectInput
                value={
                  configEmailsList[configActiveIndex].key === 'signUp'
                    ? configEmailsList[configActiveIndex].value.subject
                    : configEmailsList[configActiveIndex].value[lang].subject
                }
                onChange={(e) => updateConfigChanges(lang, 'subject', e.target.value)}
              ></SubjectInput>
              <QuillEditor
                id={`${lang}Html`}
                placeholder="Email template"
                className="quill-email"
                height="250px"
                value={
                  configEmailsList[configActiveIndex].key === 'signUp'
                    ? configEmailsList[configActiveIndex].value.html
                    : configEmailsList[configActiveIndex].value[lang].html
                }
                addPlaceholder={true}
                onChange={(updatedValue, delta, source) =>
                  updateConfigChanges(lang, 'html', updatedValue, source, delta)
                }
              />
            </EmailContainer>
          );
        })}
      </EmailTabContainer>
      {/* End of config emails */}

      {/* Start of boilerPlate emails */}
      <EmailTabContainer grids={_.size(boilerPlateEmailsList)}>{renderBoilerPlateTabs()}</EmailTabContainer>
      <EmailTabContainer grids={2} gridGap="35">
        {['en', 'sv'].map((lang, index) => {
          return (
            <EmailContainer key={index}>
              <SubjectLabel>{lang === 'en' ? 'English' : 'Swedish'} Subject</SubjectLabel>
              <SubjectInput
                value={boilerPlateEmailsList[boilerPlateActiveKey][lang].subject}
                onChange={(e) => updateBoilerPlateChanges(lang, 'subject', e.target.value)}
              ></SubjectInput>
              <QuillEditor
                id={`${lang}Html`}
                placeholder="Email template"
                className="quill-email"
                height="250px"
                value={boilerPlateEmailsList[boilerPlateActiveKey][lang].html}
                onChange={(updatedValue, delta, source) =>
                  updateBoilerPlateChanges(lang, 'html', updatedValue, source, delta)
                }
                addPlaceholder
              />
            </EmailContainer>
          );
        })}
      </EmailTabContainer>
      {/* End of boilerPlate emails */}

      <Button
        small
        primaryBlue
        primaryGreenBorder
        removeMargin
        margin="15px 0 0 0px"
        onClick={() => {
          boilerPlateEmails.value = boilerPlateEmailsList;
          updateEmails([...configEmailsList, boilerPlateEmails]);
        }}
      >
        Save
      </Button>
    </OuterContainer>
  );
};
